import React from 'react'

import { LntTag } from '@app/components/base'

import { TAG_TYPE } from '@app/constants/tag'

import { MONITORING_TASK_STATUS, MONITORING_TASK_STATUS_TITLE } from '@app/api/constants'

import { ObjectValuesType } from '@app/types'

import type { LntTagType } from '@app/components/base/Tag/types'

type StatusType = ObjectValuesType<typeof MONITORING_TASK_STATUS> | null

const matchStatusToTagType = (status: ObjectValuesType<typeof MONITORING_TASK_STATUS> | null): LntTagType => {
  switch (status) {
    case MONITORING_TASK_STATUS.FORMING:
    case MONITORING_TASK_STATUS.START:
    case MONITORING_TASK_STATUS.IN_PROGRESS:
    case MONITORING_TASK_STATUS.PROCESSING:
    case MONITORING_TASK_STATUS.SENT_TO_BW:
      return TAG_TYPE.primary

    case MONITORING_TASK_STATUS.NEEDS_CORRECTION:
    case MONITORING_TASK_STATUS.NEEDS_VERIFYING:
    case MONITORING_TASK_STATUS.VERIFYING:
      return TAG_TYPE.primary

    case MONITORING_TASK_STATUS.SEND_TO_BW_ERROR:
    case MONITORING_TASK_STATUS.STOPPED:
      return TAG_TYPE.danger

    case MONITORING_TASK_STATUS.DONE:
      return TAG_TYPE.success

    default:
      return TAG_TYPE.default
  }
}

const statusToTagText = (status: StatusType): string => {
  if (!status) return 'Не определен'

  return MONITORING_TASK_STATUS_TITLE[status]
}

export const MonitoringsTaskStatusTagRender: React.FC<{ status: StatusType }> = ({ status }) => {
  const type = matchStatusToTagType(status)
  const statusText = statusToTagText(status)

  return <LntTag type={ type }>{ statusText }</LntTag>
}
